import React from "react";

import * as S from './styles'
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import Loading from "src/components/Loading";

function RecargaAutomatica() {
  const { data, isLoading } = useFetchContent();

  if (isLoading || !data) return <Loading />;

  return (
    <S.Container>
      <S.TitleContent>
          <h1>Recarga automática</h1>
          <h2>Uma tranquilidade para você nunca ficar sem saldo.</h2>
      </S.TitleContent>
      <S.BodyContent>
          <S.Item>
          <img src='/bradescoexclusive/assets/check.svg' alt='check' />
            <span>Faça a primeira recarga a partir de R$50.</span>
          </S.Item>
          <S.Item>
          <img src='/bradescoexclusive/assets/check.svg' alt='check' />
            <span>Sempre que o saldo chegar em 30%, nós recarregaremos automaticamente no cartão cadastrado.</span>
          </S.Item>
          <S.Item>
            <img src='/bradescoexclusive/assets/check.svg' alt='check' />
            <span>Você também pode realizar recargas manuais quando quiser pelo app Veloe.</span>
          </S.Item>
      </S.BodyContent>
    </S.Container>
  );
}

export default RecargaAutomatica;
